import React from "react";
import { Formik, Form } from "formik";
import { Box, CircularProgress, Typography } from "@mui/material";
import StageFooter from "./StageFooter";
import AmbientSurfaceConditionTable from "./AmbientSurfaceConditionTable";
import WeatherTemperatureConditionsForm from "./WeatherTemperatureConditionsForm";
import useBlasting from "../hooks/useBlasting";
import StageInactive from "./ViewRFI/StageInactive";
const Blasting = ({
  formEnabled,
  showAction,
  showSubmitButton,
  awaitingReview,
  stage,
  isAPICallAllowed,
  isActive,
}) => {
  const {
    validationSchema,
    initialValues,
    stageLoading,
    handleSubmit,
    createSendForApprovalHandler,
  } = useBlasting(stage.stage_id, isAPICallAllowed);

  return (
    <>
      {isActive ? (
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            setFieldValue,
            setTouched,
            validateForm,
            submitForm,
            isSubmitting,
          }) => (
            <Box sx={{ minHeight: "100vh" }}>
              {stageLoading ? (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <CircularProgress />
                </Box>
              ) : (
                <Form>
                  {/* Weather & Temperature Conditions */}
                  <WeatherTemperatureConditionsForm
                    values={values}
                    errors={errors}
                    touched={touched}
                    setFieldValue={setFieldValue}
                    viewOnly={!formEnabled}
                  />

                  {/* Ambient & Surface Condition Table */}
                  <AmbientSurfaceConditionTable
                    values={values}
                    errors={errors}
                    touched={touched}
                    setFieldValue={setFieldValue}
                    viewOnly={!formEnabled}
                    stageType="blasting"
                  />

                  <StageFooter
                    showAction={showAction}
                    showSubmitButton={showSubmitButton}
                    onSendForApproval={
                      formEnabled &&
                      createSendForApprovalHandler(
                        validateForm,
                        submitForm,
                        setTouched
                      )
                    }
                    isSubmitting={isSubmitting}
                    awaitingReview={awaitingReview}
                    stage={stage}
                  />
                </Form>
              )}
            </Box>
          )}
        </Formik>
      ) : (
        <StageInactive />
      )}
    </>
  );
};

export default Blasting;
